export const assetsConst = {
  Logo: 'assets/images/logo.svg',
  Order: 'assets/images/order.svg',
  noDataFound: 'assets/images/Nodat-found.gif',
  ProductIcon: 'assets/images/cubes.png',
  InventoryIcon: 'assets/images/inventory_icon.png',
  OrderIcon: 'assets/images/manage_order.svg',
  EarningIcon: 'assets/images/packaging_price.svg',
  starIcon: 'assets/images/star.png',
  ord3: 'assets/images/ord3.svg',
  placeHolder: 'assets/images/placeholder.png',
  dashBoardIcon: 'assets/images/dash.svg',
  userIcon: 'assets/images/user.svg',
  bankIcon: 'assets/images/user.svg',
  reportIcon: 'assets/images/reports.svg',
  subAdminIcon: 'assets/images/sub_admin.svg',
  loanIcon: 'assets/images/sub_admin.svg',
  analyticsIcon: 'assets/images/earn_report.svg',
  cmsIcon: 'assets/images/cms.svg',
  qtyIcon: 'assets/images/qty.svg',
  addIcon: 'assets/images/add.svg',
  deleteIcon: 'assets/images/delete_icon.svg',
  logoutLogo: 'assets/images/logout.svg',
  passwordLogo: 'assets/images/password.svg',
  userLogo: 'assets/images/user.svg',
  profileLogo: 'assets/images/profile.png',
  placeHolderLogo: 'assets/images/placeholder.png',
  logoIcon: 'assets/images/logo.png',
  fixedRate: 'assets/images/fixed_rate.png',
  noteIcon: 'assets/images/notification-bell.png',
  categoryIcon: 'assets/images/category.svg',

  questionIcon: 'assets/images/question.png',
  edit_icon: 'assets/images/edit_icon.svg',
  viewIcon: 'assets/images/eye.svg',
  UserProfile: 'assets/images/user.png',
  cameraIcon: 'assets/images/camera_icon.svg',
  searchIcon: 'assets/images/search_icon.svg'
};
